(function () {
  function init() {
    setupVariantAvailability();
    setupVatInfoModals();
    setupSecondImage();
  }

  /**
   * Dynamically hide unavailable "Drawers" options based on the selected width.
   */
  function setupVariantAvailability() {
    var productInfo = document.querySelector('product-info[data-product-handle]');
    if (!productInfo) return;

    var productHandle = productInfo.getAttribute('data-product-handle');
    if (!productHandle) return;

    function updateDrawersOnly(product) {
      var widthIndex = product.options.findIndex(function (option) {
        return option.name === 'Width';
      });
      var drawersIndex = product.options.findIndex(function (option) {
        return option.name === 'Drawers';
      });
      if (widthIndex === -1 || drawersIndex === -1) return;

      var availableVariants = product.variants.map(function (variant) {
        return {
          id: variant.id,
          width: variant.options[widthIndex],
          drawers: variant.options[drawersIndex],
          available: variant.available,
        };
      });

      var selectedWidth =
        document.querySelector("input[type='radio'][name='options[Width]']:checked") ||
        document.querySelector("select[name='options[Width]'] option:checked");
      selectedWidth = selectedWidth ? selectedWidth.value : null;

      document.querySelectorAll("input[type='radio'][name='options[Drawers]']").forEach(function (input) {
        var drawerValue = input.value;
        var label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');

        var isOptionAvailable = availableVariants.some(function (variant) {
          return variant.width === selectedWidth && variant.drawers === drawerValue && variant.available;
        });

        if (!isOptionAvailable) {
          input.style.display = 'none';
          if (label) label.style.display = 'none';
        } else {
          input.style.display = 'block';
          if (label) label.style.display = 'block';
        }
      });

      // Listen for changes to the width selection and update the drawers accordingly bugfix/OB-168
      var variantRadios = document.querySelector('variant-radios');
      if (variantRadios) {
        variantRadios.addEventListener('change', function(event) {
          if (event.target.name !== 'options[Width]') return;

          var newWidth = event.target.value;
          var selectedDrawer = document.querySelector(
            "input[type='radio'][name='options[Drawers]']:checked"
          );
          if (!selectedDrawer) return;

          var currentDrawerIsValid = availableVariants.some(function(v) {
            return v.width === newWidth && v.drawers === selectedDrawer.value && v.available;
          });

          if (!currentDrawerIsValid) {
            // Find the first valid drawer for the new width
            var fallback = availableVariants.find(function(v) {
              return v.width === newWidth && v.available;
            });
            if (fallback) {
              var fallbackInput = document.querySelector(
                "input[type='radio'][name='options[Drawers]'][value='" + CSS.escape(fallback.drawers) + "']"
              );
              if (fallbackInput) {
                fallbackInput.checked = true;
                // No dispatchEvent needed — VariantSelects hasn't run yet,
                // it will read the corrected state when it fires next
              }
            }
          }
        }, true);
      }
    }

    fetch('/products/' + productHandle + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (product) {
        if (!product || !product.variants) return;

        updateDrawersOnly(product);

        // variant-selects gets fully re-rendered on option change, so re-run after each variantChange
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          updateDrawersOnly(product);
        });
      })
      .catch(function (error) {
        console.error('Error fetching product data:', error);
      });
  }

  /**
   * Open the VAT relief info modal when its trigger button is clicked.
   * Uses event delegation so it works for any number of blocks.
   */
  function setupVatInfoModals() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.js-vat-info');
      if (!trigger) return;

      var modalId = trigger.getAttribute('data-vat-modal');
      if (!modalId) return;

      var modal = document.getElementById(modalId);
      if (!modal) return;

      modal.classList.add('active');

      if (!modal.dataset.vatCloseBound) {
        modal.dataset.vatCloseBound = 'true';
        modal.addEventListener('click', function (closeEvent) {
          if (
            !closeEvent.target.closest('.expanding-blocks-modal__close') &&
            closeEvent.target.closest('.expanding-blocks-modal__card')
          )
            return;

          modal.classList.remove('active');
        });
      }
    });
  }

  /**
   * When enabled via the product metafield, auto-select the configured thumbnail.
   */
  function setupSecondImage() {
    var config = document.querySelector('[data-pdp-second-image]');
    if (!config) return;

    var imageIndex = config.getAttribute('data-pdp-second-image');
    var thumbnail = document.querySelector('.thumbnail-list__item[data-index="' + imageIndex + '"] button');
    if (!thumbnail) return;
    thumbnail.click();
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
